<h2 mat-dialog-title class="text-lg font-bold mb-1">Mover</h2>
<mat-dialog-content class="modal-content">
    <form [formGroup]="editOrderForm">
        <div class="grid grid-cols-2 gap-x-4">
            <mat-form-field appearance="fill" class="w-full">
                <mat-label class="block text-gray-700">Oficina de Venta</mat-label>
                <mat-select formControlName="salesOffice" name="salesOffice" (selectionChange)="changeSearchRoute()">
                <mat-option>
                    <ngx-mat-select-search [(ngModel)]="searchOffice" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="changueOptionsSalesOffice($event)" placeholderLabel="Buscar oficina..."
                        noEntriesFoundLabel="No se encontraron resultados">
                    </ngx-mat-select-search>
                </mat-option>
                @for (office of listFilterSalesOfficeList(); track office) {
                <mat-option [value]="office._id">
                    <b *ngIf="getCode(office) as code">{{ code }} - </b>{{ office.name }}
                </mat-option>
                }
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="w-full">
                <mat-label class="block text-gray-700">Grupo de Rutas</mat-label>
                <mat-select formControlName="routeGroup" (selectionChange)="changeSearchRoute()">
                <mat-option *ngFor="let routes of routeGroup()" [value]="routes._id">{{routes.name}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="w-full">
                <mat-label class="block text-gray-700">Ruta</mat-label>
                <mat-select formControlName="route" (selectionChange)="changeRoute()">
                <mat-option>
                    <ngx-mat-select-search [(ngModel)]="searchRoute" [ngModelOptions]="{standalone: true}"
                        (ngModelChange)="changueOptionsRoute($event)" placeholderLabel="Buscar ruta..."
                        noEntriesFoundLabel="No se encontraron resultados">
                    </ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let route of listFilterRoutesList()" [value]="route._id">{{route.name}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="w-full">
                <mat-label class="block text-gray-700">Viaje</mat-label>
                <mat-select formControlName="trip" (selectionChange)="cleanDeliveryDate(); changeTrip();">
                <mat-option *ngFor="let trip of trips()" [value]="trip._id">
                    {{trip.id}}
                    <span class="f-10">
                    <i>( Desde: {{trip?.dateHourStartTeoric | FormatDateHour: false}} Hasta {{trip?.dateHourEndTeoric | FormatDateHour: false }} )</i>
                    <strong class="ml-2" [ngClass]="{
                            'text-blue-500': trip?.statusTripId === StatusEnum.TRIP_CREATED,
                            'text-amber-500': trip?.statusTripId === StatusEnum.TRIP_READY_TO_START,
                            'text-green-500': trip?.statusTripId === StatusEnum.TRIP_IN_PROCESS
                        }">
                        [{{ getTripStatusLabel(trip?.statusTripId) }}]
                    </strong>
                    </span>
                </mat-option>
                </mat-select>
                <mat-hint *ngIf="trips() && trips().length === 0">No se encontro viajes</mat-hint>
            </mat-form-field>
        </div>

        <div class="flex flex-row gap-2">
            <mat-form-field class="w-full">
                <mat-label>Fecha y Hora de Entrega</mat-label>
                <input matInput [matDatepicker]="dateDe" formControlName="dateDelivery" [min]="minDate" [max]="maxDate">
                <mat-datepicker-toggle matIconSuffix [for]="dateDe"></mat-datepicker-toggle>
                <mat-datepicker #dateDe></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="fill" class="w-full">
                <mat-label></mat-label>
                <mat-icon matSuffix>schedule</mat-icon>
                <input matInput formControlName="timeDelivery"
                name="timeDelivery" placeholder="Inicio" [min]="minTime"
                [ngxTimepicker]="default2"
                />
                <ngx-material-timepicker #default2></ngx-material-timepicker>
            </mat-form-field>
        </div>
        
        <div *ngIf="this.editOrderForm.value.trip" class="w-full">
            <span class="block text-gray-700">Fecha de Carga </span>
            {{this.editOrderForm.value.dateLoad | FormatDateHour: false}} {{this.editOrderForm.value.timeLoad}} 
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    <button mat-raised-button color="primary" class="justify-end"
        (click)="updateOrder()" [disabled]="isOtherRoute"
        >Guardar</button>
</mat-dialog-actions>

<ng-template #confirmDialog let-data>
    <div class="flex items-start space-x-2 mb-4">
        <div class="flex items-center">
            <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6" style="font-size: 32px"></mat-icon>
        </div>
        <div class="grid">
            <h2 mat-dialog-title class="text-lg font-bold mb-1">
                {{data.title}}
            </h2>
            <mat-dialog-content class="modal-content mt-0">
                <p>{{data.message}}</p>
            </mat-dialog-content>
        </div>
    </div>
    <mat-dialog-actions class="modal-actions flex justify-end">
        <button mat-button mat-dialog-close class="align-left">
            Conservar
        </button>
        <button mat-raised-button color="warn" [mat-dialog-close]="true">
            Aceptar
        </button>
    </mat-dialog-actions>
</ng-template>

<!-- <ng-template #confirmBpDialog let-data>
    <div class="p-4 max-w-md">
      <div class="flex items-start space-x-4">
            <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500" style="font-size: 36px"></mat-icon>
            <div>
                <h2 class="text-lg font-semibold text-gray-800">Cliente con Ruta Incorrecta</h2>
                <p class="text-sm text-gray-600">Los siguientes clientes no pertenecen a la ruta seleccionada:</p>
        
                <div class="max-h-60 overflow-y-auto mt-2">
                    <ul class="text-sm text-gray-700 list-disc pl-5">
                    <li *ngFor="let order of data.invalidOrders">
                        {{ order.shipToName }} <span class="font-semibold">(Pedido: {{ order.serial }})</span>
                    </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="flex justify-end mt-4">
            <button mat-raised-button color="primary" [mat-dialog-close]="true">Aceptar</button>
        </div>
    </div>
</ng-template> -->

<ng-template #confirmBpDialog let-data>
    <div class="p-6 max-w-2xl bg-white rounded-xl shadow-lg">
        <div class="flex items-start gap-4">
            <div class="shrink-0 pt-1">
                <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-amber-500"
                    style="width: 36px; height: 36px;"></mat-icon>
            </div>

            <div class="grow">
                <h2 class="text-xl font-bold text-gray-900 mb-2">Cliente con Territorio Incorrecta</h2>
                <p class="text-sm text-gray-600 mb-4">Los siguientes clientes no pertenecen a la ruta seleccionada o no tienen un territorio(s) asignado:</p>

                <div class="border border-gray-200 rounded-lg overflow-hidden">
                    <div class="max-h-96 overflow-y-auto">
                        <table class="min-w-full divide-y divide-gray-200">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Cliente
                                    </th>
                                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Pedido
                                    </th>
                                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Territorio(Cliente)</th>
                                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Territorio(Ruta)</th>
                                </tr>
                            </thead>
                            <tbody class="bg-white divide-y divide-gray-200">
                                <tr *ngFor="let order of data.invalidOrders" class="hover:bg-gray-50">
                                    <td class="px-4 py-3 text-sm font-medium text-gray-900">
                                        {{ order.shipToName }}
                                    </td>
                                    <td class="px-4 py-3 text-sm font-semibold">
                                        {{ order.serial }}
                                    </td>
                                    <td class="px-4 py-3 text-sm text-gray-500">
                                        <div class="flex flex-wrap gap-1">
                                            <span *ngFor="let route of order.prepareClientRoutes | slice:0:1"
                                                class="px-2 py-1 text-xs rounded bg-blue-50 text-blue-700">
                                                {{ route.displayText }}
                                            </span>
                                            
                                            <!-- More routes indicator with popover -->
                                            <span *ngIf="order.prepareClientRoutes?.length > 1" class="px-2 py-1 text-xs rounded bg-blue-100 text-blue-800 cursor-pointer"
                                                [matMenuTriggerFor]="routesMenu">
                                                +{{order.prepareClientRoutes.length - 1}} mas
                                            </span>
                                            
                                            <mat-menu #routesMenu="matMenu">
                                                <div class="p-2 max-w-xs">
                                                    <div class="text-sm font-medium text-gray-700 mb-1">Territorio(s)</div>
                                                    <div class="flex flex-col gap-1">
                                                        <span *ngFor="let route of order.prepareClientRoutes" class="px-2 py-1 text-xs rounded bg-blue-50 text-blue-700">
                                                            <b *ngIf="getCode(route) as code">{{ code }} - </b>{{ route.name }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </mat-menu>
                                        </div>
                                    </td>
                                    <td class="px-4 py-3 text-sm font-medium text-gray-900">
                                     <div class="flex flex-wrap gap-1">
                                            <span *ngFor="let route of order.selectedRoutes | slice:0:1"
                                                class="px-2 py-1 text-xs rounded bg-blue-50 text-blue-700">
                                                {{ route.displayText }}
                                            </span>
                                            
                                            <!-- More routes indicator with popover -->
                                            <span *ngIf="order.selectedRoutes?.length > 1" class="px-2 py-1 text-xs rounded bg-blue-100 text-blue-800 cursor-pointer"
                                                [matMenuTriggerFor]="routesMenu">
                                                +{{order.selectedRoutes.length - 1}} mas
                                            </span>
                                            
                                            <mat-menu #routesMenu="matMenu">
                                                <div class="p-2 max-w-xs">
                                                    <div class="text-sm font-medium text-gray-700 mb-1">Territorio(s)</div>
                                                    <div class="flex flex-col gap-1">
                                                        <span *ngFor="let route of order.selectedRoutes" class="px-2 py-1 text-xs rounded bg-blue-50 text-blue-700">
                                                            <b *ngIf="getCode(route) as code">{{ code }} - </b>{{ route.name }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </mat-menu>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="mt-6 flex justify-end gap-3">
                    <button mat-flat-button color="primary" [mat-dialog-close]="true">
                       Aceptar
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #orderDetailConfirmDialog let-data>
  <div class="flex items-start space-x-2 mb-4">
    <div class="flex items-center">
      <mat-icon svgIcon="heroicons_outline:exclamation-triangle" class="text-red-500 ml-4 mt-6"
        style="font-size: 32px"></mat-icon>
    </div>
    <div class="grid">
        <h2 mat-dialog-title class="text-lg font-bold mb-1">
          {{data.title}}
        </h2>
        <mat-dialog-content class="modal-content mt-0">
          <p>{{data.message}}</p>
        </mat-dialog-content>
    </div>
  </div>
  <mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button mat-dialog-close class="align-left">
      Cancelar
    </button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true">
      Aceptar
    </button>
  </mat-dialog-actions>
</ng-template>